<section class="hero pt-7 pb-5 py-md-7">
  <div class="container">
    <div class="row g-4 align-items-center">
      <div class="col-12 col-lg-6 text-center">
        <h1 class="h2 mb-3">The #1 Go-To Marketplace for Your Charity or Event.</h1>
        <p class="fs-lg mb-5">
          Charity Booster gives charities the right professionals, products and resources to reduce stress when raising
          funds so they can greatly impact their cause and magnify their mission.
        </p>
        <a [routerLink]="['/', AppRoutes.Products]" class="btn btn-primary btn-lg mb-0"> See Our Products </a>
      </div>
      <div class="col-12 col-lg-6 d-flex align-items-center justify-content-center">
        <img
          [src]="staticImagesUrl + 'assets/images/demo/homepage/charitybooster-hero.jpg'"
          alt="Charitybooster Hero"
          class="img img-fluid"
          fetchpriority="high"
          loading="eager"
        />
      </div>
    </div>
  </div>
</section>
